import * as moment from 'moment'

class PublicCensusInfo {
  version: string
  censusDate: moment.Moment
  publicNotes: string
  customInfo: any

  fromWire(raw: any) {
    if (raw) {
      this.version = raw.Version;
      this.publicNotes = raw.PublicNotes;
      this.censusDate = moment.utc(raw.CensusDate);
      this.customInfo = raw.CustomInfo
    } else {
      this.version = '';
      this.publicNotes = '';
      this.censusDate = moment.utc();
    }
  }
}

const theCensusInfo: PublicCensusInfo = new PublicCensusInfo()

export {
  PublicCensusInfo,
  theCensusInfo
}



// WEBPACK FOOTER //
// ./src/app/services/models/PublicCensusInfo.ts